import * as React from 'react';
import { Button } from '@material-ui/core';

interface OwnProps {
  history: any;
};
export const CloseBackButton: React.SFC<OwnProps> = (props: OwnProps) => {
  // historyがあれば戻る。なければ閉じる。
  return (
    <div
      style={{
        display: 'table',
        tableLayout: 'fixed',
        width: '100%'
      }}
    >
      <div style={{
        display: 'table-cell',
        verticalAlign: 'top',
        padding: '10px'
      }}>
        {
          (props.history.length === 1)
            ? <Button
                variant="contained"
                onClick={() => window.close()}
              >
                閉じる
              </Button>
            : <Button
                variant="contained"
                onClick={() => props.history.goBack()}
              >
                戻る
              </Button>
        }
      </div>
      <div style={{
        textAlign: 'right',
        display: 'table-cell',
        verticalAlign: 'top',
        padding: '10px'
      }}>
        {' '}
      </div>
    </div>
  );
};




// WEBPACK FOOTER //
// ./src/components/parts/CloseBackButton.tsx